// extracted by mini-css-extract-plugin
export var copy = "OptionalCard-module--copy--f363e";
export var image = "OptionalCard-module--image--8879e";
export var optionalCard = "OptionalCard-module--optional-card--15976";